<script setup lang="ts">
import { DateComp } from '@/components';
import type { EventNameDateId } from '@/objects/generated';
import { type SearchType as _SearchType } from '@/objects/generated/enums/SearchType';

defineProps<{
    item: EventNameDateId;
    searchValueSnapshot: string;
    markSearchText: (text: string, searchType: _SearchType, searchValueSnapshot: string) => string;
    prettifyOutput: (text: string) => string;
    SearchType: _SearchType;
}>();
</script>
<template>
    <div v-html="markSearchText(prettifyOutput(item.Text!), SearchType, searchValueSnapshot)"></div>
    <span class="small">
        <DateComp
            :value="item.Date"
            :format="'DATE'"
        ></DateComp>
        {{ item.Description }}
    </span>
</template>
